import { API_URL, API_USER_URL } from "@/env";
import { message } from "antd";
import { PackageAPI, PackageListAPI, PaymentInfo, RegistrationPackageResponse } from "./type";

const API_USE = API_USER_URL || '';

async function getPackagesList(limit = 10, page = 1): Promise<PackageListAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/packages`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });
        if (!response.ok) {
            message.error('Error fetching packages list');
        }
        const data = await response.json();
        return data.data as PackageListAPI;
    } catch (error) {
        console.error('Failed to fetch packages list:', error);
        throw error;
    }
}

async function getPackageDetail(packageId: number): Promise<PackageAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        message.error('No authentication token found');
        return Promise.reject('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/packages/${packageId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });
        if (!response.ok) {
            message.error('Error fetching package detail');
        }
        const data = await response.json();
        return data.data as PackageAPI;
    } catch (error) {
        console.error('Failed to fetch package detail:', error);
        return Promise.reject(error);
    }
}

async function registrationPackage(packageId: number, contractFile: File, contractCode: string, userInfo: { full_name: string, id: string }, contract_annex_file?: File, contractHash?: string): Promise<RegistrationPackageResponse> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        message.error('No authentication token found');
        return Promise.reject('No authentication token found');
    }

    try {
        const data = new FormData();
        data.append('contract_file', contractFile);
        if (contract_annex_file) {
            data.append('contract_annex_file', contract_annex_file);
        }
        data.append('contract_info[full_name]', userInfo.full_name);
        data.append('contract_info[id_number]', userInfo.id);
        data.append('contract_info[contract_code]', contractCode);
        data.append('contract_info[file_name]', contractFile.name);
        if (contractHash) {
            data.append('contract_hash', contractHash);
        }

        const response = await fetch(`${API_USE}/api/v1/be/user-packages/${packageId}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: data
        });
        if (!response.ok) {
            message.error('Error registering package');
        }
        if (response.status === 500) {
            message.error('Server error occurred while registering package');
            return Promise.reject('Server error');
        }
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Failed to register package:', error);
        return Promise.reject(error);
    }
};

async function getPaymemtInfo(packageId: number): Promise<PaymentInfo> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        message.error('No authentication token found');
        return Promise.reject('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/user-packages/${packageId}/payment-info`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });
        if (!response.ok) {
            message.error('Error fetching payment info');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Failed to fetch payment info:', error);
        return Promise.reject(error);
    }
}

async function confirmPayment(packageId: number, paymentProofFile: File, transactionCode: string): Promise<any> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        message.error('No authentication token found');
        return Promise.reject('No authentication token found');
    }

    try {
        const data = new FormData();
        data.append('transaction_code', transactionCode);
        data.append('proof_image', paymentProofFile);

        const response = await fetch(`${API_USE}/api/v1/be/user-packages/${packageId}/confirm-payment`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: data
        });
        if (!response.ok) {
            message.error('Error confirming payment');
        }
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Failed to confirm payment:', error);
        return Promise.reject(error);
    }
}



export {
    getPackagesList,
    getPackageDetail,
    registrationPackage,
    getPaymemtInfo,
    confirmPayment
};